var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/alert-circle",
    clipPath: "url(#clip0_14075_1890)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 17.25C12.4005 17.25 12.3052 17.2105 12.2348 17.1402C12.1645 17.0698 12.125 16.9745 12.125 16.875C12.125 16.7755 12.1645 16.6802 12.2348 16.6098C12.3052 16.5395 12.4005 16.5 12.5 16.5",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.5 17.25C12.5995 17.25 12.6948 17.2105 12.7652 17.1402C12.8355 17.0698 12.875 16.9745 12.875 16.875C12.875 16.7755 12.8355 16.6802 12.7652 16.6098C12.6948 16.5395 12.5995 16.5 12.5 16.5",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 13.5V5.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.5 23.25C18.713 23.25 23.75 18.213 23.75 12C23.75 5.787 18.713 0.75 12.5 0.75C6.287 0.75 1.25 5.787 1.25 12C1.25 18.213 6.287 23.25 12.5 23.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14075_1890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.ce682ad97ca0238e0ee62a6ae140b9e8.svg";
export { ForwardRef as ReactComponent };